
// file: src/components/ai/insertAtCursor.js
export function insertAtCursor(text) {
    const el = document.activeElement;
    if (!el) return;

    // Input or textarea
    if (el.tagName === "INPUT" || el.tagName === "TEXTAREA") {
        const start = el.selectionStart ?? el.value.length;
        const end = el.selectionEnd ?? el.value.length;
        const value = el.value ?? "";
        el.value = value.slice(0, start) + text + value.slice(end);
        const caret = start + text.length;
        el.selectionStart = el.selectionEnd = caret;
        el.dispatchEvent(new Event("input", { bubbles: true }));
        return;
    }

    // contenteditable
    if (el.isContentEditable) {
        const sel = window.getSelection();
        if (!sel || sel.rangeCount === 0) return;
        const range = sel.getRangeAt(0);
        range.deleteContents();
        const node = document.createTextNode(text);
        range.insertNode(node);
        // Move caret after inserted node
        range.setStartAfter(node);
        range.setEndAfter(node);
        sel.removeAllRanges();
        sel.addRange(range);
        // Trigger change-like event for frameworks
        el.dispatchEvent(new Event("input", { bubbles: true }));
    }
}